import type { IconType } from '@/ui';
import { Icon, Icons, Tag, Text } from '@/ui';
import styles from './ExperienceBadge.module.css';

export type ExperienceBadgeType = 'made-with-magic' | 'human-reviewed';

type BadgeConfig = {
  label: string;
  colorScheme: string;
  icon: IconType;
  bg?: string;
  color?: string;
};

const BADGE_CONFIG: Record<ExperienceBadgeType, BadgeConfig> = {
  'made-with-magic': {
    label: 'Made with Magic',
    colorScheme: 'pink',
    bg: 'pink.50',
    color: 'brand.600',
    icon: Icons.WandSparkles,
  },
  'human-reviewed': {
    label: 'Human reviewed',
    colorScheme: 'green',
    icon: Icons.Checkmark,
  },
};

type Props = {
  type: ExperienceBadgeType;
  isAnimating?: boolean;
};

export const ExperienceBadge = ({ type, isAnimating }: Props) => {
  const { label, colorScheme, bg, color: textColor, icon } = BADGE_CONFIG[type];

  return (
    <Tag
      className={isAnimating ? styles.animating : undefined}
      colorScheme={colorScheme}
      {...(bg && { bg })}
      {...(textColor && { color: textColor })}
      fontSize="sm"
      fontWeight="medium"
      gap="1"
      px="3"
      py="1"
      whiteSpace="normal"
    >
      <Icon as={icon} boxSize={3} />
      <Text as="span">{label}</Text>
    </Tag>
  );
};
